import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler, Injectable } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

/**
 * Catches lazy-chunk 404 errors (stale browser cache after a new deployment)
 * and triggers a single hard reload to pick up the fresh index.html + chunks.
 * The 10-second guard prevents infinite reload loops if the server itself is down.
 */
@Injectable()
class ChunkErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const msg = (error as { message?: string })?.message ?? '';
    const isChunkError =
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Loading chunk');

    if (isChunkError) {
      const key  = 'pss_chunk_reload';
      const last = parseInt(sessionStorage.getItem(key) ?? '0', 10);
      if (Date.now() - last > 10_000) {
        sessionStorage.setItem(key, String(Date.now()));
        window.location.reload();
      }
      return;
    }
    console.error(error);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptors([loadingInterceptor, jwtInterceptor])),
    { provide: ErrorHandler, useClass: ChunkErrorHandler }
  ]
};
